import type { Block } from '@lg/shared'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'blockName',
	pure: true,
	standalone: false,
})
export class BlockNamePipe implements PipeTransform {
	transform(block: any, ...args: unknown[]): unknown {
		console.log('blockName', block)
		return block.constructor.prototype.displayName
	}
}
